import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Card,
  Row,
  Col,
  Typography,
  Space,
  Divider,
  notification,
  Spin,
  Carousel,
} from "antd";
import {
  PhoneOutlined,
  UserOutlined,
  EnvironmentOutlined,
  ShopOutlined,
  CheckCircleOutlined,
  WhatsAppOutlined,
  TrophyOutlined,
  TeamOutlined,
  SafetyOutlined,
  RocketOutlined,
} from "@ant-design/icons";
import axios from "axios";
import "../../config";

const { Title, Text, Paragraph } = Typography;

const AdDiamondPendantCMP = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const config = {
        method: "post",
        url: `${global.config.APIURL.BaseURL}api/Campaign/SubmitWholesaleInquiry`,
        data: {
          mobileNumber: values.mobile,
          name: values.name,
          city: values.city,
          businessType: values.businessType || "Retailer",
          inquirySource: "Diamond Pendant Wholesale Campaign",
          timestamp: new Date().toISOString(),
        },
        headers: {
          "Content-Type": "application/json",
        },
      };

      const response = await axios.request(config);

      if (response.status === 200) {
        setSubmitted(true);
        notification.success({
          message: "Thank You for Your Interest!",
          description:
            "Our wholesale team will contact you within 24 hours with pricing and catalog.",
          duration: 5,
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      notification.error({
        message: "Submission Failed",
        description: "Please try again or contact our wholesale team directly.",
        duration: 3,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSlideChange = (current, next) => {
    setCurrentSlide(next);
  };

  // Static data - moved outside to prevent re-creation
  const wholesaleFeatures = [
    { icon: <TrophyOutlined />, text: "Premium Quality Guaranteed" },
    { icon: <RocketOutlined />, text: "Fast Delivery Nationwide" },
    { icon: <SafetyOutlined />, text: "100% Authentic Products" },
    { icon: <TeamOutlined />, text: "Dedicated Support Team" },
  ];

  const productShowcase = [
    {
      id: 1,
      title: "Diamond Pendant Collection",
      price: "₹15,000 - ₹50,000",
      wholesalePrice: "₹7,500 - ₹25,000",
      image:
        "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 300 300'><defs><linearGradient id='diamond1' x1='0%' y1='0%' x2='100%' y2='100%'><stop offset='0%' style='stop-color:%23fff;stop-opacity:1' /><stop offset='50%' style='stop-color:%23e6f3ff;stop-opacity:1' /><stop offset='100%' style='stop-color:%23b3d9ff;stop-opacity:1' /></linearGradient><linearGradient id='gold1' x1='0%' y1='0%' x2='100%' y2='100%'><stop offset='0%' style='stop-color:%23ffd700;stop-opacity:1' /><stop offset='100%' style='stop-color:%23ffb300;stop-opacity:1' /></linearGradient></defs><rect width='300' height='300' fill='%23f0f8ff'/><circle cx='150' cy='120' r='15' fill='url(%23gold1)'/><path d='M150 135 L135 180 L165 180 Z' fill='url(%23diamond1)' stroke='%23ccc' stroke-width='2'/><path d='M140 160 L160 160' stroke='%23aaa' stroke-width='1'/><path d='M145 170 L155 170' stroke='%23aaa' stroke-width='1'/><text x='150' y='220' text-anchor='middle' font-family='Arial' font-size='14' fill='%23333'>Diamond Pendant</text><text x='150' y='240' text-anchor='middle' font-family='Arial' font-size='12' fill='%23666'>Premium Quality</text></svg>",
      description: "Classic diamond pendants with certified stones",
    },
    {
      id: 2,
      title: "Diamond Earrings Set",
      price: "₹20,000 - ₹75,000",
      wholesalePrice: "₹10,000 - ₹37,500",
      image:
        "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 300 300'><defs><linearGradient id='diamond2' x1='0%' y1='0%' x2='100%' y2='100%'><stop offset='0%' style='stop-color:%23fff;stop-opacity:1' /><stop offset='50%' style='stop-color:%23e6f3ff;stop-opacity:1' /><stop offset='100%' style='stop-color:%23b3d9ff;stop-opacity:1' /></linearGradient><linearGradient id='gold2' x1='0%' y1='0%' x2='100%' y2='100%'><stop offset='0%' style='stop-color:%23ffd700;stop-opacity:1' /><stop offset='100%' style='stop-color:%23ffb300;stop-opacity:1' /></linearGradient></defs><rect width='300' height='300' fill='%23f0f8ff'/><circle cx='100' cy='120' r='8' fill='url(%23gold2)'/><path d='M100 128 L90 150 L110 150 Z' fill='url(%23diamond2)' stroke='%23ccc' stroke-width='1'/><circle cx='200' cy='120' r='8' fill='url(%23gold2)'/><path d='M200 128 L190 150 L210 150 Z' fill='url(%23diamond2)' stroke='%23ccc' stroke-width='1'/><text x='150' y='200' text-anchor='middle' font-family='Arial' font-size='14' fill='%23333'>Diamond Earrings</text><text x='150' y='220' text-anchor='middle' font-family='Arial' font-size='12' fill='%23666'>Matching Pair</text></svg>",
      description: "Elegant diamond earrings for special occasions",
    },
    {
      id: 3,
      title: "Diamond Ring Collection",
      price: "₹25,000 - ₹1,00,000",
      wholesalePrice: "₹12,500 - ₹50,000",
      image:
        "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 300 300'><defs><linearGradient id='diamond3' x1='0%' y1='0%' x2='100%' y2='100%'><stop offset='0%' style='stop-color:%23fff;stop-opacity:1' /><stop offset='50%' style='stop-color:%23e6f3ff;stop-opacity:1' /><stop offset='100%' style='stop-color:%23b3d9ff;stop-opacity:1' /></linearGradient><linearGradient id='gold3' x1='0%' y1='0%' x2='100%' y2='100%'><stop offset='0%' style='stop-color:%23ffd700;stop-opacity:1' /><stop offset='100%' style='stop-color:%23ffb300;stop-opacity:1' /></linearGradient></defs><rect width='300' height='300' fill='%23f0f8ff'/><ellipse cx='150' cy='150' rx='60' ry='20' fill='url(%23gold3)'/><ellipse cx='150' cy='150' rx='40' ry='15' fill='none' stroke='%23cc9900' stroke-width='2'/><path d='M150 135 L140 155 L160 155 Z' fill='url(%23diamond3)' stroke='%23ccc' stroke-width='2'/><text x='150' y='200' text-anchor='middle' font-family='Arial' font-size='14' fill='%23333'>Diamond Ring</text><text x='150' y='220' text-anchor='middle' font-family='Arial' font-size='12' fill='%23666'>Engagement & Wedding</text></svg>",
      description: "Stunning diamond rings for engagements and weddings",
    },
    {
      id: 4,
      title: "Diamond Necklace Set",
      price: "₹50,000 - ₹2,00,000",
      wholesalePrice: "₹25,000 - ₹1,00,000",
      image:
        "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 300 300'><defs><linearGradient id='diamond4' x1='0%' y1='0%' x2='100%' y2='100%'><stop offset='0%' style='stop-color:%23fff;stop-opacity:1' /><stop offset='50%' style='stop-color:%23e6f3ff;stop-opacity:1' /><stop offset='100%' style='stop-color:%23b3d9ff;stop-opacity:1' /></linearGradient><linearGradient id='gold4' x1='0%' y1='0%' x2='100%' y2='100%'><stop offset='0%' style='stop-color:%23ffd700;stop-opacity:1' /><stop offset='100%' style='stop-color:%23ffb300;stop-opacity:1' /></linearGradient></defs><rect width='300' height='300' fill='%23f0f8ff'/><path d='M80 100 Q150 80 220 100 Q200 120 150 130 Q100 120 80 100' fill='none' stroke='url(%23gold4)' stroke-width='4'/><circle cx='120' cy='105' r='4' fill='url(%23diamond4)'/><circle cx='150' cy='100' r='6' fill='url(%23diamond4)'/><circle cx='180' cy='105' r='4' fill='url(%23diamond4)'/><path d='M150 130 L140 160 L160 160 Z' fill='url(%23diamond4)' stroke='%23ccc' stroke-width='2'/><text x='150' y='200' text-anchor='middle' font-family='Arial' font-size='14' fill='%23333'>Diamond Necklace</text><text x='150' y='220' text-anchor='middle' font-family='Arial' font-size='12' fill='%23666'>Bridal Collection</text></svg>",
      description: "Luxurious diamond necklaces for bridal collections",
    },
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
        padding: 0,
        overflow: "hidden",
      }}
    >
      {/* Product Showcase Carousel */}
      <div
        style={{
          position: "relative",
          height: isMobile ? "400px" : "500px",
          background: "linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3))",
        }}
      >
        <Carousel
          autoplay
          autoplaySpeed={3000}
          dots={false}
          infinite
          speed={500}
          beforeChange={handleSlideChange}
          style={{ height: "100%" }}
        >
          {productShowcase.map((product) => (
            <div
              key={product.id}
              style={{ height: isMobile ? "400px" : "500px" }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  position: "relative",
                }}
              >
                <Row
                  style={{
                    width: "100%",
                    maxWidth: "1200px",
                    margin: "0 auto",
                    padding: isMobile ? "15px" : "40px",
                  }}
                  align="middle"
                  gutter={[16, 16]}
                >
                  <Col xs={24} md={12} style={{ textAlign: "center" }}>
                    <div
                      style={{
                        background: "white",
                        borderRadius: "15px",
                        padding: isMobile ? "15px" : "20px",
                        boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                        margin: "0 auto",
                        maxWidth: isMobile ? "250px" : "280px",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: isMobile ? "150px" : "180px",
                          background: `url('${product.image}') no-repeat center center`,
                          backgroundSize: "contain",
                          borderRadius: "10px",
                          marginBottom: "10px",
                        }}
                      />
                      <div style={{ textAlign: "center" }}>
                        <Text
                          style={{
                            color: "#333",
                            fontSize: isMobile ? "14px" : "16px",
                            fontWeight: "bold",
                            display: "block",
                            marginBottom: "6px",
                          }}
                        >
                          {product.title}
                        </Text>
                        <Text
                          style={{
                            color: "#666",
                            fontSize: isMobile ? "11px" : "12px",
                            display: "block",
                            marginBottom: "8px",
                          }}
                        >
                          {product.description}
                        </Text>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "8px",
                          }}
                        >
                          <div style={{ flex: 1 }}>
                            <Text
                              delete
                              style={{
                                color: "#999",
                                fontSize: isMobile ? "10px" : "12px",
                                display: "block",
                              }}
                            >
                              MRP: {product.price}
                            </Text>
                            <Text
                              strong
                              style={{
                                color: "#1890ff",
                                fontSize: isMobile ? "12px" : "14px",
                                display: "block",
                              }}
                            >
                              Wholesale: {product.wholesalePrice}
                            </Text>
                          </div>
                          <div
                            style={{
                              background: "#52c41a",
                              color: "white",
                              padding: "3px 6px",
                              borderRadius: "8px",
                              fontSize: isMobile ? "9px" : "10px",
                              fontWeight: "bold",
                            }}
                          >
                            50% OFF
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col
                    xs={24}
                    md={12}
                    style={{ textAlign: isMobile ? "center" : "left" }}
                  >
                    <div
                      style={{
                        marginTop: isMobile ? "15px" : "0",
                        padding: isMobile ? "0 10px" : "0",
                      }}
                    >
                      <Title
                        level={isMobile ? 4 : 2}
                        style={{
                          color: "white",
                          marginBottom: isMobile ? 12 : 16,
                          fontSize: isMobile ? "20px" : "36px",
                          fontWeight: "bold",
                          textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
                        }}
                      >
                        {product.title}
                      </Title>
                      <Paragraph
                        style={{
                          color: "white",
                          fontSize: isMobile ? "13px" : "18px",
                          marginBottom: isMobile ? "15px" : "20px",
                          textShadow: "1px 1px 2px rgba(0,0,0,0.5)",
                        }}
                      >
                        {product.description}
                      </Paragraph>
                      <div style={{ marginBottom: isMobile ? "15px" : "20px" }}>
                        <Text
                          style={{
                            color: "#ffd700",
                            fontSize: isMobile ? "16px" : "24px",
                            fontWeight: "bold",
                            display: "block",
                            textShadow: "1px 1px 2px rgba(0,0,0,0.5)",
                          }}
                        >
                          Wholesale: {product.wholesalePrice}
                        </Text>
                        <Text
                          delete
                          style={{
                            color: "#ccc",
                            fontSize: isMobile ? "12px" : "16px",
                            display: "block",
                            textShadow: "1px 1px 2px rgba(0,0,0,0.5)",
                          }}
                        >
                          MRP: {product.price}
                        </Text>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: isMobile ? "8px" : "12px",
                          justifyContent: isMobile ? "center" : "flex-start",
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          style={{
                            background: "rgba(255,255,255,0.2)",
                            padding: isMobile ? "6px 12px" : "8px 16px",
                            borderRadius: "15px",
                            backdropFilter: "blur(10px)",
                            border: "1px solid rgba(255,255,255,0.3)",
                          }}
                        >
                          <Text
                            style={{
                              color: "white",
                              fontSize: isMobile ? "10px" : "12px",
                            }}
                          >
                            🏆 Certified Quality
                          </Text>
                        </div>
                        <div
                          style={{
                            background: "rgba(255,255,255,0.2)",
                            padding: isMobile ? "6px 12px" : "8px 16px",
                            borderRadius: "15px",
                            backdropFilter: "blur(10px)",
                            border: "1px solid rgba(255,255,255,0.3)",
                          }}
                        >
                          <Text
                            style={{
                              color: "white",
                              fontSize: isMobile ? "10px" : "12px",
                            }}
                          >
                            🚚 Fast Delivery
                          </Text>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          ))}
        </Carousel>

        {/* Carousel Navigation Dots */}
        <div
          style={{
            position: "absolute",
            bottom: "15px",
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            gap: "6px",
            zIndex: 2,
          }}
        >
          {productShowcase.map((_, index) => (
            <div
              key={index}
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                background:
                  currentSlide === index ? "#ffd700" : "rgba(255,255,255,0.5)",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
            />
          ))}
        </div>
      </div>

      {/* Wholesale Benefits Section */}
      <div
        style={{
          padding: isMobile ? "15px 10px" : "40px 24px",
          background: "white",
          margin: isMobile ? "0 10px" : "0 24px",
          borderRadius: "15px 15px 0 0",
          marginTop: "15px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Form Section */}
        <Row justify="center">
          <Col xs={24} sm={22} md={18} lg={14}>
            <Card
              style={{
                borderRadius: 15,
                boxShadow: "0 8px 16px rgba(0,0,0,0.08)",
                border: "1px solid #1890ff",
                background: "linear-gradient(135deg, #fff 0%, #f6f8ff 100%)",
                padding: isMobile ? "10px" : "20px",
              }}
            >
              <div
                style={{
                  textAlign: "center",
                  marginBottom: isMobile ? 16 : 24,
                }}
              >
                <Title
                  level={isMobile ? 4 : 3}
                  style={{
                    color: "#333",
                    marginBottom: isMobile ? 6 : 8,
                    fontSize: isMobile ? "18px" : "24px",
                  }}
                >
                  💼 Start Your Wholesale Journey
                </Title>
                <Text
                  style={{
                    color: "#666",
                    fontSize: isMobile ? "12px" : "14px",
                  }}
                >
                  Fill the form below to get wholesale pricing and catalog
                  access
                </Text>
              </div>

              {submitted ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: isMobile ? "20px 10px" : "40px 20px",
                    background: "linear-gradient(135deg, #52c41a, #389e0d)",
                    borderRadius: 10,
                    color: "white",
                  }}
                >
                  <CheckCircleOutlined
                    style={{
                      fontSize: isMobile ? "36px" : "48px",
                      marginBottom: isMobile ? 12 : 16,
                    }}
                  />
                  <Title
                    level={isMobile ? 4 : 3}
                    style={{ color: "white", marginBottom: isMobile ? 12 : 16 }}
                  >
                    Thank You for Your Interest!
                  </Title>
                  <Paragraph
                    style={{
                      color: "white",
                      fontSize: isMobile ? "14px" : "16px",
                      marginBottom: isMobile ? 15 : 20,
                    }}
                  >
                    Our wholesale team will contact you within 24 hours with:
                  </Paragraph>
                  <div
                    style={{
                      textAlign: "left",
                      marginBottom: isMobile ? 15 : 20,
                    }}
                  >
                    <Text
                      style={{
                        color: "white",
                        display: "block",
                        marginBottom: 6,
                        fontSize: isMobile ? "13px" : "14px",
                      }}
                    >
                      ✓ Wholesale price catalog
                    </Text>
                    <Text
                      style={{
                        color: "white",
                        display: "block",
                        marginBottom: 6,
                        fontSize: isMobile ? "13px" : "14px",
                      }}
                    >
                      ✓ Minimum order quantities
                    </Text>
                    <Text
                      style={{
                        color: "white",
                        display: "block",
                        marginBottom: 6,
                        fontSize: isMobile ? "13px" : "14px",
                      }}
                    >
                      ✓ Payment terms & conditions
                    </Text>
                    <Text
                      style={{
                        color: "white",
                        display: "block",
                        fontSize: isMobile ? "13px" : "14px",
                      }}
                    >
                      ✓ Sample collection details
                    </Text>
                  </div>
                  <Button
                    type="primary"
                    size={isMobile ? "middle" : "large"}
                    icon={<WhatsAppOutlined />}
                    style={{
                      background: "#25D366",
                      borderColor: "#25D366",
                      borderRadius: 20,
                      marginTop: isMobile ? 12 : 16,
                    }}
                    onClick={() =>
                      window.open(
                        "https://wa.me/your-wholesale-whatsapp-number",
                        "_blank"
                      )
                    }
                  >
                    Chat with Wholesale Team
                  </Button>
                </div>
              ) : (
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={handleSubmit}
                  size={isMobile ? "middle" : "large"}
                >
                  <Form.Item
                    name="name"
                    label="Business Owner Name"
                    rules={[
                      { required: true, message: "Please enter your name" },
                      { min: 2, message: "Name must be at least 2 characters" },
                    ]}
                  >
                    <Input
                      prefix={<UserOutlined style={{ color: "#1890ff" }} />}
                      placeholder="Enter your full name"
                      style={{
                        borderRadius: 8,
                        padding: isMobile ? "8px 12px" : "12px 16px",
                        fontSize: isMobile ? "14px" : "16px",
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="mobile"
                    label="Mobile Number"
                    rules={[
                      { required: true, message: "Please enter mobile number" },
                      {
                        pattern: /^[6-9]\d{9}$/,
                        message: "Please enter a valid 10-digit mobile number",
                      },
                    ]}
                  >
                    <Input
                      prefix={<PhoneOutlined style={{ color: "#1890ff" }} />}
                      placeholder="Enter your mobile number"
                      maxLength={10}
                      style={{
                        borderRadius: 8,
                        padding: isMobile ? "8px 12px" : "12px 16px",
                        fontSize: isMobile ? "14px" : "16px",
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="city"
                    label="City"
                    rules={[
                      { required: true, message: "Please enter your city" },
                      { min: 2, message: "City must be at least 2 characters" },
                    ]}
                  >
                    <Input
                      prefix={
                        <EnvironmentOutlined style={{ color: "#1890ff" }} />
                      }
                      placeholder="Enter your city"
                      style={{
                        borderRadius: 8,
                        padding: isMobile ? "8px 12px" : "12px 16px",
                        fontSize: isMobile ? "14px" : "16px",
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="businessType"
                    label="Business Type (Optional)"
                  >
                    <Input
                      prefix={<ShopOutlined style={{ color: "#1890ff" }} />}
                      placeholder="e.g., Jewelry Store, Online Retailer"
                      style={{
                        borderRadius: 8,
                        padding: isMobile ? "8px 12px" : "12px 16px",
                        fontSize: isMobile ? "14px" : "16px",
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    style={{ marginTop: isMobile ? 20 : 32, marginBottom: 0 }}
                  >
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                      style={{
                        width: "100%",
                        height: isMobile ? 40 : 50,
                        borderRadius: 20,
                        fontSize: isMobile ? "16px" : "18px",
                        fontWeight: "bold",
                        background: "linear-gradient(135deg, #1890ff, #096dd9)",
                        border: "none",
                        boxShadow: "0 4px 12px rgba(24,144,255,0.3)",
                      }}
                    >
                      {loading ? <Spin /> : "Get Wholesale Pricing 💼"}
                    </Button>
                  </Form.Item>
                </Form>
              )}
            </Card>
          </Col>
        </Row>

        <Divider
          style={{
            margin: isMobile ? "20px 0" : "40px 0",
            borderColor: "#ffd700",
          }}
        />

        <Row gutter={[16, 16]} justify="center">
          <Col span={24}>
            <Title
              level={isMobile ? 3 : 2}
              style={{
                textAlign: "center",
                marginBottom: isMobile ? 20 : 32,
                color: "#333",
                fontSize: isMobile ? "20px" : "32px",
              }}
            >
              💼 Why Choose JOJ for Wholesale?
            </Title>
          </Col>
        </Row>

        <Row
          gutter={[16, 16]}
          justify="center"
          style={{ marginBottom: isMobile ? 20 : 40 }}
        >
          <Col xs={24} sm={12} md={8}>
            <Card
              style={{
                textAlign: "center",
                borderRadius: 10,
                height: "100%",
                border: "1px solid #f0f0f0",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                padding: isMobile ? "10px" : "15px",
              }}
            >
              <div
                style={{
                  fontSize: isMobile ? "36px" : "48px",
                  marginBottom: isMobile ? 8 : 16,
                }}
              >
                💰
              </div>
              <Title
                level={isMobile ? 5 : 4}
                style={{ color: "#1890ff", marginBottom: isMobile ? 8 : 12 }}
              >
                Competitive Pricing
              </Title>
              <Text
                style={{ color: "#666", fontSize: isMobile ? "12px" : "14px" }}
              >
                Get the best wholesale rates with attractive margins for your
                business growth
              </Text>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Card
              style={{
                textAlign: "center",
                borderRadius: 10,
                height: "100%",
                border: "1px solid #f0f0f0",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                padding: isMobile ? "10px" : "15px",
              }}
            >
              <div
                style={{
                  fontSize: isMobile ? "36px" : "48px",
                  marginBottom: isMobile ? 8 : 16,
                }}
              >
                📦
              </div>
              <Title
                level={isMobile ? 5 : 4}
                style={{ color: "#52c41a", marginBottom: isMobile ? 8 : 12 }}
              >
                Bulk Orders
              </Title>
              <Text
                style={{ color: "#666", fontSize: isMobile ? "12px" : "14px" }}
              >
                Minimum order quantities designed for retailers with flexible
                payment terms
              </Text>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Card
              style={{
                textAlign: "center",
                borderRadius: 10,
                height: "100%",
                border: "1px solid #f0f0f0",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                padding: isMobile ? "10px" : "15px",
              }}
            >
              <div
                style={{
                  fontSize: isMobile ? "36px" : "48px",
                  marginBottom: isMobile ? 8 : 16,
                }}
              >
                🚚
              </div>
              <Title
                level={isMobile ? 5 : 4}
                style={{ color: "#fa8c16", marginBottom: isMobile ? 8 : 12 }}
              >
                Pan-India Delivery
              </Title>
              <Text
                style={{ color: "#666", fontSize: isMobile ? "12px" : "14px" }}
              >
                Reliable delivery network covering all major cities across India
              </Text>
            </Card>
          </Col>
        </Row>

        <Row
          gutter={[16, 16]}
          justify="center"
          style={{ marginBottom: isMobile ? 20 : 40 }}
        >
          <Col xs={24} sm={12} md={8}>
            <Card
              style={{
                textAlign: "center",
                borderRadius: 10,
                height: "100%",
                border: "1px solid #f0f0f0",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                padding: isMobile ? "10px" : "15px",
              }}
            >
              <div
                style={{
                  fontSize: isMobile ? "36px" : "48px",
                  marginBottom: isMobile ? 8 : 16,
                }}
              >
                💎
              </div>
              <Title
                level={isMobile ? 5 : 4}
                style={{ color: "#722ed1", marginBottom: isMobile ? 8 : 12 }}
              >
                Certified Quality
              </Title>
              <Text
                style={{ color: "#666", fontSize: isMobile ? "12px" : "14px" }}
              >
                All diamonds are certified with quality assurance and
                authenticity guarantee
              </Text>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Card
              style={{
                textAlign: "center",
                borderRadius: 10,
                height: "100%",
                border: "1px solid #f0f0f0",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                padding: isMobile ? "10px" : "15px",
              }}
            >
              <div
                style={{
                  fontSize: isMobile ? "36px" : "48px",
                  marginBottom: isMobile ? 8 : 16,
                }}
              >
                🤝
              </div>
              <Title
                level={isMobile ? 5 : 4}
                style={{ color: "#eb2f96", marginBottom: isMobile ? 8 : 12 }}
              >
                Dedicated Support
              </Title>
              <Text
                style={{ color: "#666", fontSize: isMobile ? "12px" : "14px" }}
              >
                Personal account manager for order tracking and business support
              </Text>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Card
              style={{
                textAlign: "center",
                borderRadius: 10,
                height: "100%",
                border: "1px solid #f0f0f0",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                padding: isMobile ? "10px" : "15px",
              }}
            >
              <div
                style={{
                  fontSize: isMobile ? "36px" : "48px",
                  marginBottom: isMobile ? 8 : 16,
                }}
              >
                📈
              </div>
              <Title
                level={isMobile ? 5 : 4}
                style={{ color: "#13c2c2", marginBottom: isMobile ? 8 : 12 }}
              >
                Business Growth
              </Title>
              <Text
                style={{ color: "#666", fontSize: isMobile ? "12px" : "14px" }}
              >
                Marketing support and promotional materials to help grow your
                business
              </Text>
            </Card>
          </Col>
        </Row>

        {/* Trust Indicators */}
        <Row
          justify="center"
          style={{
            marginTop: isMobile ? 20 : 40,
            padding: isMobile ? "15px 0" : "20px 0",
            background: "linear-gradient(135deg, #f0f2f5, #e6f7ff)",
            borderRadius: 10,
          }}
        >
          <Col span={24}>
            <div
              style={{ textAlign: "center", marginBottom: isMobile ? 15 : 20 }}
            >
              <Title
                level={isMobile ? 5 : 4}
                style={{ color: "#333", marginBottom: isMobile ? 15 : 20 }}
              >
                🏆 Trusted by 500+ Retailers Across India
              </Title>
              <Space
                size={isMobile ? "middle" : "large"}
                wrap
                style={{ justifyContent: "center" }}
              >
                <div style={{ textAlign: "center" }}>
                  <Text
                    strong
                    style={{
                      fontSize: isMobile ? "16px" : "20px",
                      color: "#1890ff",
                    }}
                  >
                    500+
                  </Text>
                  <br />
                  <Text
                    style={{
                      fontSize: isMobile ? "10px" : "12px",
                      color: "#666",
                    }}
                  >
                    Partners
                  </Text>
                </div>
                <div style={{ textAlign: "center" }}>
                  <Text
                    strong
                    style={{
                      fontSize: isMobile ? "16px" : "20px",
                      color: "#52c41a",
                    }}
                  >
                    24hrs
                  </Text>
                  <br />
                  <Text
                    style={{
                      fontSize: isMobile ? "10px" : "12px",
                      color: "#666",
                    }}
                  >
                    Response
                  </Text>
                </div>
                <div style={{ textAlign: "center" }}>
                  <Text
                    strong
                    style={{
                      fontSize: isMobile ? "16px" : "20px",
                      color: "#fa8c16",
                    }}
                  >
                    Pan-India
                  </Text>
                  <br />
                  <Text
                    style={{
                      fontSize: isMobile ? "10px" : "12px",
                      color: "#666",
                    }}
                  >
                    Delivery
                  </Text>
                </div>
                <div style={{ textAlign: "center" }}>
                  <Text
                    strong
                    style={{
                      fontSize: isMobile ? "16px" : "20px",
                      color: "#722ed1",
                    }}
                  >
                    Certified
                  </Text>
                  <br />
                  <Text
                    style={{
                      fontSize: isMobile ? "10px" : "12px",
                      color: "#666",
                    }}
                  >
                    Quality
                  </Text>
                </div>
              </Space>
            </div>
          </Col>
        </Row>
      </div>

      {/* Footer */}
      <div
        style={{
          textAlign: "center",
          padding: isMobile ? "15px" : "20px",
          background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
          color: "white",
        }}
      >
        <Text style={{ color: "white", fontSize: isMobile ? "12px" : "14px" }}>
          © 2024 JOJ Jewelry - Wholesale Division. All rights reserved.
        </Text>
      </div>
    </div>
  );
};

export default AdDiamondPendantCMP;
